<ng-container
    *ngIf="{
        scheduledForMove: scheduledForMove$ | async,
        currentlyMoving: currentlyMoving$ | async,
        customerNames: customerNames$ | async,
        undoScheduledLoading: undoScheduledLoading$ | async,
    } as accounts"
>
    <nz-alert
        *ngIf="accounts.currentlyMoving?.length"
        nzShowIcon
        nzType="info"
        [nzDescription]="currentlyMovingTmpl"
        class="move-moving"
    >
        <ng-template #currentlyMovingTmpl>
            <div class="move-content a-fx a-fx-between-start a-fx-gap-120">
                <div class="a-fx-col a-fx-gap-4">
                    <div class="a-color-white">
                        <strong>{{ 'common.account-move.moving-title' | translate }}</strong>
                    </div>

                    <div
                        *ngFor="let account of accounts.currentlyMoving; trackBy: trackByAccount"
                        class="move-accounts-account"
                    >
                        &bull;&nbsp; {{ account.accountName }}
                    </div>
                </div>

                <div class="move-description" [innerHTML]="'common.account-move.moving-description' | translate"></div>
            </div>
        </ng-template>
    </nz-alert>

    <nz-alert *ngIf="accounts.scheduledForMove?.length" nzShowIcon nzType="info" [nzDescription]="scheduledForMoveTmpl">
        <ng-template #scheduledForMoveTmpl>
            <adspt-accordion [expanded]="showDetails$ | async">
                <div *adsptAccordionHeader class="a-fx a-fx-between-center a-fx-gap-32">
                    <div class="move-title a-fx-col a-fx-gap-8 a-fx-flex">
                        <div class="h3">
                            {{ 'common.account-move.scheduled-title' | translate }}
                        </div>

                        <div>
                            {{ 'common.account-move.scheduled-description' | translate }}
                        </div>
                    </div>

                    <div class="a-fx a-fx-start-center a-fx-gap-16">
                        <button
                            nz-button
                            nzType="default"
                            class="move-show-details a-fx-none"
                            (click)="showDetails$.next()"
                        >
                            <span>
                                {{
                                    ((showDetails$ | async)
                                        ? 'common.account-move.hide-details'
                                        : 'common.account-move.show-details'
                                    ) | translate
                                }}
                            </span>

                            <i nz-icon style="pointer-events: none">
                                <adspt-icon name="caret-down" *ngIf="!(showDetails$ | async)" />

                                <svg *ngIf="showDetails$ | async" class="adspt-icon">
                                    <use xlink:href="#adspt-cross-circle"></use>
                                </svg>
                            </i>
                        </button>

                        <button
                            *ngIf="canMove$ | async"
                            nz-button
                            nzType="primary"
                            class="a-fx-none"
                            [nzLoading]="undoingAll$ | async"
                            (click)="undoAll()"
                        >
                            {{ 'common.account-move.undo-all' | translate }}
                        </button>
                    </div>
                </div>

                <div *adsptAccordionExpandedContent class="move-details a-fx-col a-fx-gap-4">
                    <div class="h4">
                        {{ 'common.account-move.enqueued-accounts' | translate }}
                    </div>

                    <table class="move-accounts">
                        <tr *ngFor="let account of accounts.scheduledForMove; trackBy: trackByAccount">
                            <td class="move-accounts-account">
                                &bull;&nbsp;
                                <ng-container *ngIf="account.customerChangeTarget">
                                    {{
                                        'common.account-move.account-to-be-moved-to-customer'
                                            | translate
                                                : {
                                                      accountName: account.accountName,
                                                      customerName:
                                                          accounts.customerNames[account.customerChangeTarget],
                                                  }
                                    }}
                                </ng-container>

                                <ng-container *ngIf="!account.customerChangeTarget">
                                    {{
                                        'common.account-move.account-to-be-moved'
                                            | translate: { accountName: account.accountName }
                                    }}
                                </ng-container>
                            </td>

                            <td *ngIf="canMove$ | async">
                                <div class="a-fx a-fx-start-center a-fx-gap-4">
                                    <span
                                        class="a-text-underline a-color-light-blue a-fx-none a-cursor-pointer"
                                        [class.undo-disabled]="
                                            accounts.undoScheduledLoading?.[account.adspertAccountId] ||
                                            (undoingAll$ | async)
                                        "
                                        (click)="onUndoMove(account.adspertAccountId)"
                                    >
                                        {{ 'common.account-move.undo' | translate }}
                                    </span>

                                    <nz-spin
                                        *ngIf="accounts.undoScheduledLoading?.[account.adspertAccountId]"
                                        class="a-fx-none"
                                        nzSize="small"
                                    ></nz-spin>
                                </div>
                            </td>
                        </tr>
                    </table>
                </div>
            </adspt-accordion>
        </ng-template>
    </nz-alert>
</ng-container>
